import { useLoadMore } from "@/hooks/useLoadMore";
import { getTourList, type TourListItem, type TourCategory } from "@/api/tour";
import { DURATION_VALUE_MAP } from "../constants";
import TourCard from "./TourCard";

interface TourListProps {
  categories: TourCategory[];
  activeTag: number;
  activeDuration: number;
  keyword: string;
  minPrice: string;
  maxPrice: string;
  isRecommend?: number;
  isHot?: number;
  isReplaceMode: boolean;
  onSelect: (id: number) => void;
}

export default function TourList({
  activeDuration,
  keyword,
  minPrice,
  maxPrice,
  isReplaceMode,
  onSelect,
}: TourListProps) {
  const {
    list,
    total,
    loading,
    hasMore,
    containerRef,
  } = useLoadMore<TourListItem>({
    pageSize: 10,
    deps: [activeDuration, keyword, minPrice, maxPrice],
    fetcher: async (page) => {
      const res = await getTourList({
        page,
        limit: 10,
        days: DURATION_VALUE_MAP[activeDuration] !== undefined
          ? DURATION_VALUE_MAP[activeDuration]
          : undefined,
        keyword: keyword || undefined,
        min_price: minPrice ? Number(minPrice) : undefined,
        max_price: maxPrice ? Number(maxPrice) : undefined,
      });
      return res.data.data;
    },
  });

  return (
    <div
      ref={containerRef}
      className="px-4 pt-2 space-y-3"
    >
      {/* Results count */}
      <div className="px-0 pt-1 pb-1">
        <span className="text-xs text-gray-400">
          共 <span className="font-semibold text-gray-700">{total}</span> 条线路
        </span>
      </div>

      {loading && list.length === 0 ? (
        <div className="flex items-center justify-center py-10">
          <span className="text-xs text-gray-400">加载中...</span>
        </div>
      ) : (
        <>
          {list.map((tour) => (
            <TourCard
              key={tour.id}
              tour={tour}
              isReplaceMode={isReplaceMode}
              onSelect={onSelect}
            />
          ))}

          {loading && list.length > 0 && (
            <div className="text-center py-4">
              <span className="text-xs text-gray-400">加载中...</span>
            </div>
          )}

          {!hasMore && list.length > 0 && (
            <div className="text-center py-4">
              <span className="text-xs text-gray-400">没有更多了</span>
            </div>
          )}

          {list.length === 0 && !loading && (
            <div className="text-center py-10">
              <span className="text-xs text-gray-400">暂无线路</span>
            </div>
          )}
        </>
      )}
    </div>
  );
}
